export default __webpack_public_path__ + "static/media/6.56bf1c03.png";